<template>
    <b-form @submit.prevent="save">
        <b-card no-body>
            <b-card-body bg-variant="light">
                <b-row>
                    <b-col md="3" sm="3">
                        <lg-form-input invalidFeedback="Este campo não pode ser vazio!" description=" "
                            v-model="form.dataAtualFormadata" label="Data:*" disabled />
                    </b-col>
                    <b-col md="9" sm="9">
                        <lg-form-input invalidFeedback="Este campo não pode ser vazio!" description=" "
                            v-model="form.descricao" :error="$v.form.descricao" label="Descrição:*" />
                    </b-col>
                </b-row>

                <b-row class="align-items-center mt-2">
                    <b-col md="5" sm="12" class="ml-3">
                        <b-form-checkbox v-if="temPrivilegioIncluir()" v-model="form.devolucaoAoDeposito"
                            @change="devolucaoAoDepositoChange" id="checkbox-1">
                            <span style="font-size: 13px">Devolução ao Depósito</span>
                        </b-form-checkbox>
                    </b-col>
                    <b-col md="6" sm="12">
                        <lg-form-input v-if="temPrivilegioIncluir()" :disabled="true"
                            :value="form.devolucaoAoDeposito ? (form.departamento && form.departamento.descricao ? form.departamento.descricao : '') : ''"
                            description=" " style="margin-bottom: 0" />

                    </b-col>
                </b-row>
                <b-row class="align-items-center mb-1">
                    <b-col md="12" class="ml-3">
                        <b-form-checkbox v-if="temPrivilegioIncluir()" @change="movimentacaoDiretaChange"
                            v-model="form.movimentacaoDireta" id="checkbox-2">
                            <span style="font-size: 13px">
                                Movimentação direta entre unidades administrativas (Sem apoio patrimonial)
                            </span>
                        </b-form-checkbox>
                    </b-col>
                </b-row>
                <b-row v-if="form.movimentacaoDireta && temPrivilegioIncluir()" class="align-items-center mb-2">
                    <b-col md="4" sm="12" class="d-flex align-items-center">
                        <span style="font-size: 13px">Replicar unidade administrativa destino</span>
                    </b-col>
                    <b-col md="8" sm="12">
                        <lg-finder-page-unidade-administrativa id="finderUnidadeAdministrativa"
                            :prefix="prefix + title + ' > '" ref="finderUnidadeAdministrativa" label=""
                            @onselect="replicarUnidade" v-model="form.departamentoDestino"
                            :podeApagarDepartamento="form.movimentacaoDireta"
                            :podeMudarDepartamento="form.movimentacaoDireta" />
                    </b-col>
                </b-row>

                <b-row class="mb-2">
                    <b-col cols="12" class="text-right">
                        <b-button v-if="temPrivilegioIncluir()" id="novo" class="ml-3 mr-2 my-2" style="height: 32px"
                            @click="mostrarModal" size="sm" pill variant="secondary">
                            <div class="btn-size-alinhamento">
                                <b-icon scale="1" icon="plus" />
                            </div>
                            <b-tooltip target="novo" title="Adicionar novo..."></b-tooltip>
                        </b-button>
                    </b-col>
                </b-row>

                <b-card bg-variant="light" class="mt-2">
                    <b-table responsive :busy="this.busy" :items="form.itens" :fields="this.tableFields" :hover="true"
                        show-empty>
                        <template #table-busy>
                            <div class="text-center text-primary my-2">
                                <b-spinner class="align-middle"></b-spinner>
                            </div>
                        </template>

                        <template v-slot:cell(action)="row">
                            <b-button :id="row.index + 'excluir-devolucao-movimentacao'" class="my-2" size="sm" pill
                                variant="primary" @click="remove(row.item)">
                                <b-icon icon="trash-fill" />
                                <b-tooltip :target="row.index + 'excluir-devolucao-movimentacao'"
                                    title="Remover..."></b-tooltip>
                            </b-button>
                        </template>

                        <template v-slot:cell(destino)="row">
                            <div style="margin-top: 4px">
                                <span v-if="form.devolucaoAoDeposito">
                                    {{ row.item.departamentoDestino.descricao }}
                                </span>
                                <div v-if="form.movimentacaoDireta" class="mt-2">
                                    <lg-finder-page-unidade-administrativa v-model="row.item.departamentoDestino"
                                        id="finderUnidadeAdministrativa" :prefix="prefix + title + ' > '"
                                        ref="finderUnidadeAdministrativa" label=""
                                        @onselect="(item) => replicarUnidadeLocal(row.item, item)" />
                                </div>
                            </div>
                        </template>

                        <template #empty>
                            <p>Selecione algum Item Bem Permanente</p>
                        </template>
                    </b-table>
                    <b-row style="margin-top: 12px" v-if="form.itens && form.itens.length > 0">
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                            <span>Página {{ 1 }} de {{ 10 }} - {{ form.itens.length }} registros</span>
                        </b-col>
                        <b-col cols="6">
                            <div class="d-flex justify-content-end align-items-end">
                                <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                    :per-page="perPage" :total-rows="total"></b-pagination>
                            </div>
                        </b-col>
                    </b-row>
                </b-card>

                <b-row>
                    <b-col cols="12" class="d-flex justify-content-end">
                        itens selecionados: {{ form.itens.length }}
                    </b-col>
                </b-row>

                <b-form-row class="justify-content-center">
                    <b-button id="salvarLocalCadastro" class="my-2" size="sm" pill variant="success" @click="save">
                        <b-icon icon="check-circle" />
                        <b-tooltip target="salvarLocalCadastro" title="Salvar"></b-tooltip>
                    </b-button>
                </b-form-row>
            </b-card-body>
        </b-card>
        <ModalPageItemBemPermanente :prefix="prefix + title + ' > '" @onselect="selecionarItem" @cancelar="fecharModal"
            v-if="showModal"></ModalPageItemBemPermanente>
    </b-form>
</template>

<script>
import ResourceService from "@/core/api/ResourceService";
import { required } from "vuelidate/lib/validators";
import { isoDate } from "../../almoxarifados/registros-entrada/utils/isoData";
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import LgFinderPageUnidadeAdministrativa from "@/components/Finders/LgFinderPageUnidadeAdministrativa.vue";
import { FormResourceMixin, ListResourceMixin } from "@/core/mixins/resource";
import ConfirmMixin from "@/core/mixins/confirm";
import ModalPageItemBemPermanente from "@/core/components/Modals/ModalPageItemBemPermanente.vue"

import verificaPrivilegio from "@/utils/VerificaPrivilegio"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"

export default {
    components: {
        LgFormInput,
        LgFinderPageUnidadeAdministrativa,
        ModalPageItemBemPermanente
    },
    props: {
        prefix: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            default: "Devolução/Movimentação Simplificada",
        }
    },


    async beforeMount() {

        this.form.dataAtualFormadata = this.formatDate(this.form.dataAtual);
        this.$service = new ResourceService(`/api/solicitacaomovimentacaosimplificada`);
        this.$itemService = new ResourceService(`/api/itembempermanente`);
        this.brand = JSON.parse(localStorage.getItem("context"));
        this.form.departamento = this.brand.departamento;
        this.form.usuarioResponsavel = this.brand.usuario;
        this.busy = false;

    },
    data() {
        return {
            perPage: 10,
            perPageOptions: [10, 25, 50, 100],
            showModal: false,
            form: {
                dataAtualFormadata: "",
                devolucaoAoDeposito: false,
                movimentacaoDireta: false,
                descricao: "",
                itens: [],
                departamento: {},
                departamentoDestino: {},
                dataAtual: isoDate(),
            },

        };
    },
    mixins: [ListResourceMixin, FormResourceMixin, ConfirmMixin],
    validations: {
        form: {
            descricao: {
                required,
            },
        },
    },
    computed: {
        formIsValid() {
            return !this.$v.$invalid;
        },
        tableFields() {
            return [

                { key: "numTombamento", label: "Nº Tombamento" },
                { key: "itemRegEntrada.produto.numero", label: "Número" },
                {
                    key: "itemRegEntrada.produto.descricaoResumida",
                    label: "Descrição",
                },
                { key: "lotacao.departamento.descricao", label: "Origem" },
                { key: "destino", label: "Destino", thStyle: "width: 35%" },
                { key: "action", label: " ", thClass: "w-1" },

            ];
        },
    },
    methods: {


        temPrivilegioIncluir() {
            return verificaPrivilegio(PrivilegiosEnum.DEVOLUCAO_MOVIMENTACAO_SIMPLIFICADA_INCLUIR);

        },

        temPrivilegioGerenciarPatrimonio() {
            return verificaPrivilegio(PrivilegiosEnum.GERENCIAR_PATRIMONIO);

        },

        formatDate(dateString) {
            const date = new Date(dateString);

            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');

            return `${day}/${month}/${year} ${hours}:${minutes}`;
        },
        remove(item) {
            this.form.itens.splice(
                this.form.itens.indexOf(item),
                1
            );

        },
        fecharModal() {
            this.showModal = false;
        },
        mostrarModal() {
            this.showModal = true;
        },
        async selecionarItem(itemSelecionado) {

            this.fecharModal();


            const found = this.form.itens.find(
                item => item.id === itemSelecionado.id
            );

            this.busy = true;
            if (found) {
                this.$notify({
                    type: "danger",
                    message: "Item Bem Permanente já vinculado!",
                });
                return;
            }

            this.$itemService.findById(itemSelecionado.id).then(response => {

                var novoItem = response.data;
                novoItem.departamentoDestino = { id: null, descricao: "" };


                if (this.form.movimentacaoDireta) {
                    novoItem.departamentoDestino.id = this.form.departamentoDestino.id;
                    novoItem.departamentoDestino.descricao = this.form.departamentoDestino.descricao;

                }
                else if (this.form.devolucaoAoDeposito) {
                    novoItem.departamentoDestino.id = this.form.departamento.id;
                    novoItem.departamentoDestino.descricao = this.form.departamento.descricao;

                }

                this.form.itens.push(novoItem);
                this.busy = false;

            });



        },
        movimentacaoDiretaChange(valor) {


            if (valor) {
                this.form.devolucaoAoDeposito = false;

                this.form.itens.forEach(item => {
                    item.departamentoDestino.id = this.form.departamentoDestino.id;
                    item.departamentoDestino.descricao = this.form.departamentoDestino.descricao;

                });

            }



        },
        devolucaoAoDepositoChange(valor) {


            if (valor) {

                this.form.movimentacaoDireta = false;
                this.form.departamentoDestino.id = null;
                this.form.departamentoDestino.descricao = "";

                this.form.itens.forEach(item => {

                    item.departamentoDestino.id = this.form.departamento.id;
                    item.departamentoDestino.descricao = this.form.departamento.descricao;


                });


            }



        },
        replicarUnidade(item) {
            this.form.departamentoDestino = item;
            this.form.itens.forEach(item => {
                item.departamentoDestino.id = this.form.departamentoDestino.id;
                item.departamentoDestino.descricao = this.form.departamentoDestino.descricao;

            });


        },

        replicarUnidadeLocal(item, departamentoDestino) {
            item.departamentoDestino.id = departamentoDestino.id;
            item.departamentoDestino.descricao = departamentoDestino.descricao;

        },



        async save() {


            if (!this.formIsValid || (this.form.movimentacaoDireta && (!this.form.departamentoDestino || !this.form.departamentoDestino.id)) || (!this.form.devolucaoAoDeposito && !this.form.movimentacaoDireta) || this.form.itens.some(item => !item.departamentoDestino || !item.departamentoDestino.id)
            ) {
                this.$v.$touch();
                this.$notify({
                    type: "danger",
                    message: "Verifique os campos do cadastro.",
                });
                return;
            }

            

            if (this.form.itens.length == 0) {
                this.$notify({
                    type: "danger",
                    message: "Selecione ao menos um Item Bem Permanente",
                });
                return;

            }

            await this.$saveResource(this.form, "", false, {}, false, true);


            this.form = {
                devolucaoAoDeposito: false,
                movimentacaoDireta: false,
                descricao: "",
                itens: [],
                departamento: this.form.departamento,
                departamentoDestino: {},
                dataAtual: isoDate(),
                dataAtualFormadata: this.formatDate(isoDate()),
            };


        },
    },
};
</script>
